import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Nav } from "react-bootstrap";
import classNames from "classnames";
import { Link } from "react-router-dom";
import AppContext from "context/Context";
import styles from "./landing.module.css";
import { useTranslation } from "react-i18next";
import store from "reducers/store";
import NavbarVerticalMenuItem from "components/navbar/vertical/NavbarVerticalMenuItem";

const NavbarNavLink = ({ title, route, selected, isParent, selectedChild, onClick }) => {
	const [t, i18n] = useTranslation();
	const {
		config: { navbarCollapsed, showBurgerMenu },
		setConfig,
	} = useContext(AppContext);

	const handleClick = () => {
		if (navbarCollapsed) {
			setConfig("navbarCollapsed", !navbarCollapsed);
		}
		if (showBurgerMenu) {
			setConfig("showBurgerMenu", !showBurgerMenu);
		}
		if (onClick) onClick();
	};
	return (
		<Nav.Link
			as={title ? "span" : Link}
			className={classNames("fw-medium", styles.mainPageMenu, {
				[styles.mainPageMenuSelected]: selected,
				[styles.menuParentHeader]: isParent,
				[styles.menuChildSelect]: selectedChild,
				"text-500": !route?.active,
				"mb-0 fw-bold": title,
				"py-1": !title && !selected,
				"link-600": !title && route?.active,
			})}
			to={route?.to}
			onClick={handleClick}
			state={{ pagename: route.name }}
		>
			{/* {title ? t(title) : t(route.name)} */}
			<NavbarVerticalMenuItem route={route} />
		</Nav.Link>
	);
};

NavbarNavLink.propTypes = {
	title: PropTypes.string,
	route: PropTypes.shape({
		name: PropTypes.string.isRequired,
		to: PropTypes.string,
		active: PropTypes.bool,
	}),
};

export default NavbarNavLink;
